function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["element", "title", "ingress", "image", "imageAlt", "imageRatio", "linkText", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, oneOfType, oneOf, func, object } from 'prop-types';
import './NavigationCard.scss';
import Card from '../Card/Card';
import Image from '../Image/Image';
import Icon from '../Icon/Icon';
import classNames from 'classnames';
import { ArrowRightIcon } from '@ruter-ds/rds-icons';
var propTypes = {
  /** The type of html element you need. `a` or `Link` (from react router) are the most common.
   * Example usage with React Router: `<NavigationCard element={Link} to="/somepage" />` */
  element: oneOfType([string, func, object]),

  /** The title of the card */
  title: string,

  /** The ingress */
  ingress: string,

  /** The text in the visual presentation of a link */
  linkText: string,

  /** The image. Will be cropped to the image ratio you choose. Make sure you use an appropriate ratio to match your image */
  image: string,

  /** Always provide an alt text describing the image.
   * The alt attribute provides alternative information for an image
   * if a user for some reason cannot view it (because of slow connection,
   * an error in the src attribute, or if the user uses a screen reader). Example: `<Image src="bird.jpg" alt="A bird sitting on a branch. Photo." />`
   *
   * If the image is inside a link, the _target_ should be described, not the motif:
   * `<a href="buy-tickets.html"><Image src="image.jpg" alt="Buy tickets" /></a>`
   *
   * If the image is purely for decoration, provide an empty alt attribute: `<Image src="decoration.jpg" alt="" />` */
  imageAlt: string,

  /** Choose the ratio of your image */
  imageRatio: oneOf(['none', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  element: 'a',
  imageRatio: '16:9',
  imageAlt: ''
};
/**
 * A NavigationCard is used to provide the user with information about the target link.
 * @visibleName Navigation Card
 * */

var NavigationCard = /*#__PURE__*/function (_Component) {
  _inherits(NavigationCard, _Component);

  var _super = _createSuper(NavigationCard);

  function NavigationCard() {
    _classCallCheck(this, NavigationCard);

    return _super.apply(this, arguments);
  }

  _createClass(NavigationCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          element = _this$props.element,
          title = _this$props.title,
          ingress = _this$props.ingress,
          image = _this$props.image,
          imageAlt = _this$props.imageAlt,
          imageRatio = _this$props.imageRatio,
          linkText = _this$props.linkText,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var componentClassNames = classNames('rds-navigation-card', className);
      return /*#__PURE__*/React.createElement(Card, _extends({
        element: element,
        className: componentClassNames
      }, rest), image && /*#__PURE__*/React.createElement(Image, {
        ratio: imageRatio,
        src: image,
        alt: imageAlt,
        className: "rds-navigation-card__image"
      }), /*#__PURE__*/React.createElement("div", {
        className: "rds-navigation-card__content"
      }, title && /*#__PURE__*/React.createElement("h2", {
        className: "rds-navigation-card__title"
      }, title), ingress && /*#__PURE__*/React.createElement("p", {
        className: "rds-navigation-card__ingress"
      }, ingress), linkText && /*#__PURE__*/React.createElement("span", {
        className: 'rds-card-link rds-navigation-card__link'
      }, /*#__PURE__*/React.createElement(Icon, {
        component: /*#__PURE__*/React.createElement(ArrowRightIcon, null),
        className: "rds-card-link__icon",
        size: "small"
      }), /*#__PURE__*/React.createElement("span", null, linkText))));
    }
  }]);

  return NavigationCard;
}(Component);

NavigationCard.propTypes = propTypes;
NavigationCard.defaultProps = defaultProps;
export default NavigationCard;